<template>
  <div>
    <!-- only types that need a catalog -->
    <checkbox-config
      v-if="config && config.type === 'checkbox'"
      :data.sync="data"
      :config="config"
      @update:data="onDataUpdated"
    />
    <select-config
      v-else-if="config && config.type === 'select'"
      :data.sync="data"
      :config="config"
      @update:data="onDataUpdated"
    />
    <!--no extra config -->
    <div v-else class="text-muted small">
      {{ $t('custom_forms.no_extra_config') }}
    </div>
  </div>
</template>

<script>
import CheckboxConfig from "./CheckboxConfig.vue";
import SelectConfig from "./SelectConfig.vue";

export default {
  name: "SecuritySelfAuditFieldTypeConfig",
  components: { CheckboxConfig, SelectConfig },
  props: {
    fieldTypeCfg: { type: Object, default: () => ({ data: [] }) },
    config: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      data: { data: [] },
    };
  },
  created() {
    const src = this.fieldTypeCfg || {};
    this.data = JSON.parse(
      JSON.stringify(Array.isArray(src.data) ? src : { ...src, data: [] })
    );
  },
  methods: {
    onDataUpdated(newData) {
      if (!Array.isArray(newData?.data)) newData = { ...(newData || {}), data: [] };
      this.data = newData;
      this.$emit("update:data", this.data);
    },
  },
  watch: {
    data: {
      deep: true,
      handler(val) {
        if (!Array.isArray(val?.data)) val = { ...(val || {}), data: [] };
        this.$emit("update:data", val);
      },
    },
    fieldTypeCfg: {
      deep: true,
      handler(nv) {
        const src = nv || {};
        this.data = JSON.parse(
          JSON.stringify(Array.isArray(src.data) ? src : { ...src, data: [] })
        );
      },
    },
  },
};
</script>
